// runResultEvent.js — monta o EVENTO run_result que dirige o PlanState no fim de um
// run de turno único (SessionWorkspace). PURO (o caller passa o carimbo `at`).
// @arch:pure-engine
//
// P1b — liga o RunOutcome canônico ao produtor real SEM tocar o gate sagrado: `ok`
// segue byte-idêntico ao legado (planRunHonestlyDone), e ADICIONA `outcome`
// (fromAgentResult) que o reducer PREFERE. Assim o plano passa a distinguir
// verified × implemented_unverified e a PAUSAR de forma acionável quando o ambiente
// não deu pra verificar (env), em vez de fabricar verde silencioso — sem nunca
// concluir onde o gate honesto disse que não entregou (invariante testada em P1).

import { planRunHonestlyDone } from './planHonestOutcome.js';
import { fromAgentResult } from '../outcome/fromExisting.js';

/**
 * @param {{ finished?: boolean, aborted?: boolean, agentResult?: any, at?: number, root?: string }} p
 *   root — cwd da sessão; viaja p/ dentro do outcome (evidence.root) só no estado de
 *   ambiente, pro env-notice rodar o install no diretório certo.
 * @returns {{ type: 'run_result', ok: boolean, outcome: import('../outcome/runOutcome.js').RunOutcome, at: number|undefined }}
 */
export function buildRunResultEvent({ finished, aborted, agentResult, at, root } = {}) {
  const outcome = fromAgentResult({ finished, aborted, agentResult, root });
  // `ok` = gate honesto legado, INTACTO (fallback p/ quem não lê outcome). O reducer,
  // quando vê `outcome`, ignora `ok` e usa o outcome (mais rico e igualmente honesto).
  return { type: 'run_result', ok: planRunHonestlyDone({ finished, aborted, agentResult }), outcome, at };
}
